<template>
  <div class="app-main-inner">
    <el-dialog
      ref="dialog"
      :visible.sync="visible"
      :title="title"
      width="1100px"
      :close-on-click-modal="false"
      :show-close="false"
      class="make-invoice-step-two-dialog"
      top="5vh"
      @open="showDialog"
    >
      <div v-if="properties.isHedge" class="app-main-inner-row" style="padding: 0 0 0 20px; height: 28px;">
        <el-form :inline="true" label-width="60px" label-position="right">
          <span style="font-size: 14px;">{{ $t('Invoice.invoice_receivables') }}</span>
          <el-form-item :label="$t('Invoice.invoice_currency')">
            <el-radio-group v-model="properties.receivedRadio" no="receivedRadio" class="h-dense-radio-group" @change="currencyRadioByReceivedChange">
              <el-radio label="ALL">{{ $t('Invoice.invoice_all') }}</el-radio>
              <el-radio label="RMB">RMB</el-radio>
              <el-radio label="USD">USD</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="visible" id="vsPage1" class="app-main-inner-row row-grid" style="height: 420px; padding: 0;">
        <cargo-ag-grid
          v-if="vsPage1_makeInvoiceMethod===1 || vsPage1_makeInvoiceMethod===2"
          class="chargeGrid1"
          config-module="1906081"
          :grid-params.sync="chargeGrid.gridParams"
          :grid-options="chargeGrid.gridOptions"
          :column-defs="chargeGrid.columnDefs"
          :row-data="vsPage1_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage1"
        />
        <cargo-ag-grid
          v-if="vsPage1_makeInvoiceMethod===3"
          class="billingGrid1"
          config-module="1906082"
          :grid-params.sync="billingGrid.gridParams"
          :grid-options="billingGrid.gridOptions"
          :column-defs="billingGrid.columnDefs"
          :row-data="vsPage1_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage1"
        />
        <cargo-ag-grid
          v-if="vsPage1_makeInvoiceMethod===4"
          class="billingGroupGrid1"
          config-module="1906083"
          :grid-params.sync="billingGroupGrid.gridParams"
          :grid-options="billingGroupGrid.gridOptions"
          :column-defs="billingGroupGrid.columnDefs"
          :row-data="vsPage1_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage1"
        />
        <cargo-ag-grid
          v-if="vsPage1_makeInvoiceMethod===5"
          class="billingPaymentGrid1"
          config-module="1906084"
          :grid-params.sync="billingPaymentGrid.gridParams"
          :grid-options="billingPaymentGrid.gridOptions"
          :column-defs="billingPaymentGrid.columnDefs"
          :row-data="vsPage1_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage1"
        />
      </div>
      <div v-if="properties.isHedge" style="display: flex; justify-content: flex-end; padding-right: 10px; font-size: 12px; background-color: #f5f7f7;">
        <span v-text="$t('Invoice.invoice_subTotal')" />
        <charge-currency-total-group
          v-if="reCalc"
          :key="1"
          mode="group"
          type="ar"
          data-field="amount"
          rate-field="invoiceRate"
          currency-field="currency"
          :ar-field="arField"
          :data-provider="charge1"
          :amount-to-currency="properties.currency"
        />
      </div>
      <div v-if="properties.isHedge" class="app-main-inner-row" style="padding: 0 0 0 20px; height: 28px;">
        <el-form :inline="true" label-width="60px" label-position="right">
          <span style="font-size: 14px;">{{ $t('Invoice.invoice_payables') }}</span>
          <el-form-item :label="$t('Invoice.invoice_currency')">
            <el-radio-group v-model="properties.paymentRadio" no="paymentRadio" class="h-dense-radio-group" @change="currencyRadioByPaymentChange">
              <el-radio label="ALL">{{ $t('Invoice.invoice_all') }}</el-radio>
              <el-radio label="RMB">RMB</el-radio>
              <el-radio label="USD">USD</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="properties.isHedge && visible" id="vsPage2" class="app-main-inner-row row-grid" style="height: 420px; padding: 0;">
        <cargo-ag-grid
          v-if="vsPage2_makeInvoiceMethod===1 || vsPage2_makeInvoiceMethod===2"
          class="chargeGrid2"
          config-module="1906085"
          :grid-params.sync="chargeGrid_vsPage2.gridParams"
          :grid-options="chargeGrid_vsPage2.gridOptions"
          :column-defs="chargeGrid.columnDefs"
          :row-data="vsPage2_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage2"
        />
        <cargo-ag-grid
          v-if="vsPage2_makeInvoiceMethod===3"
          class="billingGrid2"
          config-module="1906086"
          :grid-params.sync="billingGrid_vsPage2.gridParams"
          :grid-options="billingGrid_vsPage2.gridOptions"
          :column-defs="billingGrid.columnDefs"
          :row-data="vsPage2_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage2"
        />
        <cargo-ag-grid
          v-if="vsPage2_makeInvoiceMethod===4"
          class="billingGroupGrid2"
          config-module="1906087"
          :grid-params.sync="billingGroupGrid_vsPage2.gridParams"
          :grid-options="billingGroupGrid_vsPage2.gridOptions"
          :column-defs="billingGroupGrid.columnDefs"
          :row-data="vsPage2_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage2"
        />
        <cargo-ag-grid
          v-if="vsPage2_makeInvoiceMethod===5"
          class="billingPaymentGrid2"
          config-module="1906088"
          :grid-params.sync="billingPaymentGrid_vsPage2.gridParams"
          :grid-options="billingPaymentGrid_vsPage2.gridOptions"
          :column-defs="billingPaymentGrid.columnDefs"
          :row-data="vsPage2_rowData"
          style="width: 100%;"
          @gridReady="onGridReady_vsPage2"
        />
      </div>
      <div v-if="properties.isHedge" style="display: flex; justify-content: flex-end; padding-right: 10px; font-size: 12px; background-color: #f5f7f7;">
        <span v-text="$t('Invoice.invoice_subTotal')" />
        <charge-currency-total-group
          v-if="reCalc"
          :key="2"
          mode="group"
          type="ap"
          data-field="amount"
          rate-field="invoiceRate"
          currency-field="currency"
          :ar-field="arField"
          :data-provider="charge2"
          :amount-to-currency="properties.currency"
        />
      </div>
      <div style="width:100%;display: flex; justify-content: space-between; padding:5px 10px; font-size: 13px; background-color: #f5f7f7;">
        <div style="flex:1;display: flex;flex-wrap: wrap;justify-content: flex-start">
          <el-form :inline="true" label-width="40px" label-position="right" style="display: inline-block;">
            <span v-if="properties.txtCurrency1!==''" style="vertical-align: middle">{{ $t('Invoice.invoice_currency') }} </span>&nbsp;&nbsp;<span v-if="properties.txtCurrency1!==''" style="font-weight: bold;vertical-align: middle">{{ properties.txtCurrency1 }}<i class="el-icon-right" />{{ properties.currency }}</span>
            <el-form-item v-if="properties.txtCurrency1!==''" :label="$t('Invoice.invoice_exchangeRate')" :label-width="$selectByLang('', '95px')">
              <num-input v-model="properties.txtRate1" no="txtRate1" :precision="8" :truncated-precision="txtRate1Precision" :disabled="showCollectInvoiceWindow" style="width: 95px;" @change="txtRate1Change" />
            </el-form-item>
            <span v-if="properties.txtCurrency2!==''" style="vertical-align: middle">{{ $t('Invoice.invoice_currency') }} </span>&nbsp;&nbsp;<span v-if="properties.txtCurrency2!==''" style="font-weight: bold;vertical-align: middle">{{ properties.txtCurrency2 }}<i class="el-icon-right" />{{ properties.currency }}</span>
            <el-form-item v-if="properties.txtCurrency2!==''" :label="$t('Invoice.invoice_exchangeRate')" :label-width="$selectByLang('', '95px')">
              <num-input v-model="properties.txtRate2" no="txtRate2" :precision="8" :truncated-precision="txtRate2Precision" :disabled="showCollectInvoiceWindow" style="width: 95px;" @change="txtRate2Change" />
            </el-form-item>
          </el-form>
        </div>
        <div style="display: inline-block;text-align: right;margin-right: -10px">
          <span v-text="$t('Invoice.invoice_total')" />
          <charge-currency-total-group
            v-if="reCalc"
            :key="3"
            mode="group"
            type="revenueAbs"
            data-field="amount"
            rate-field="invoiceRate"
            currency-field="currency"
            source="invoiceDetail"
            :ar-field="arField"
            :data-provider="allCharge"
            :amount-to-currency="properties.currency"
            :currency-conversion-in-invoices="currencyConversionInInvoices"
          />
        </div>
      </div>
      <div v-if="!showCollectInvoiceWindow" slot="footer">
        <span>
          <el-button v-if="!properties.isHedge" :disabled="properties.isEtowerOne" no="toAutoSplitCharge" type="primary" @click="toAutoSplitCharge">{{ $t('Invoice.AutoSplitCharge') }}</el-button>
          <el-button type="primary" no="toSplitCharge" :disabled="properties.isEtowerOne" @click="toSplitCharge">{{ $t('Invoice.invoice_sp31') }}</el-button>
          <el-button type="primary" no="toLast" @click="toLast">{{ $t('Invoice.invoice_back') }}</el-button>
          <el-button v-if="unInvoiceCreate" type="primary" no="doNexInvoice" @click="doNexInvoice">{{ $t('Invoice.invoice_next') }}</el-button>
          <el-button v-if="!unInvoiceCreate" type="primary" no="doMakeInvoice" @click="doMakeInvoice">{{ isCollectInvoice ? $t('Invoice.invoice_collectInvoiceConfirmation') : $t('Invoice.invoice_invoiceConfirmation') }}</el-button>
          <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </div>
      <!--下面用作收票查看明细相关按钮-->
      <div v-if="showCollectInvoiceWindow" style="height: 470px; padding: 0;">
        <collect-invoice-window ref="collectInvoiceWindow" :properties="properties" />
      </div>
      <div v-if="showCollectInvoiceWindow" slot="footer" class="dense-btns">
        <span>
          <el-button type="primary" :disabled="!(properties.currentPage>1)" no="108" @click="btPreClickHandler">{{ $t('Invoice.invoice_theLastPage') }}</el-button>
          <el-button type="primary" :disabled="!(properties.currentPage<properties.totalPage)" no="109" @click="btNextClickHandler">{{ $t('Invoice.invoice_theNextPage') }}</el-button>
          <span style="font-size: 14px; margin-left: 6px;">{{ properties.currentPage }} / {{ properties.totalPage }}</span>
        </span>
        <span>
          <el-button type="primary" no="toLast2" @click="showCollectInvoiceWindow = false">{{ $t('Invoice.invoice_back') }}</el-button>
          <el-button type="primary" no="doMakeInvoice" @click="doMakeInvoice">{{ isCollectInvoice ? $t('Invoice.invoice_collectInvoiceConfirmation') : $t('Invoice.invoice_invoiceConfirmation') }}</el-button>
          <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
    <!--  费用拆分弹窗页  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="splitChargeDialog.show"
      :title="$t('CargoMsg.Cargo_Sp31')"
      width="760px"
      class="make-invoice-step-two-split-charge-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        :inline="true"
        :model="splitChargeDialog.splitChargeForm"
        label-width="70px"
        label-position="right"
      >
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
            <span>{{ splitChargeDialog.charge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.charge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')">
            <span>{{ splitChargeDialog.charge.amount }}</span>
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_SplitExpenseP')">
            <span>{{ splitChargeDialog.splitCharge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.splitCharge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.amount"
              no="amount"
              :precision="2"
              controls-position="right"
              :controls="false"
              @change="amountChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxExcludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.excludingTaxAmount"
              no="excludingTaxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item label=" " />
          <el-form-item label=" " />
          <el-form-item :label="$t('CargoMsg.Cargo_TaxAmountP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxAmount"
              no="taxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxRateP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxRate"
              no="taxRate"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <span style="position: absolute; left: 0; padding-left: 10px;">
          <el-checkbox v-model="splitChargeDialog.onlyChangeQuantity" no="onlyChangeQuantity" @change="onlyChangeQuantityChangeHandler">{{ $t('Invoice.invoice_SplitChargeOnlyChangeQuantity') }}</el-checkbox>
        </span>
        <el-button no="ok" type="primary" :disabled="splitChargeDialog.btnSplitEnable" @click="doSplitCharge">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="splitChargeDialog.show = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 自动拆分费用弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="autoSplitChargeDialog.visible"
      :title="$t('Invoice.AutoSplitCharge')"
      width="630px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        :inline="true"
        :model="autoSplitChargeDialog.chargeOrigin"
        label-width="90px"
        label-position="right"
      >
        <div style="border-bottom: 1px solid #000000;height: 100px;">
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.chargeName }}</span>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.currency }}</span>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.amount }}</span>
            </el-form-item>
          </div>
          <div class="el-form-item-wrapper">
            <el-form-item :label="$t('CargoMsg.Cargo_SplitExpenseP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.chargeName }}</span>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
              <span>{{ autoSplitChargeDialog.chargeOrigin.currency }}</span>
            </el-form-item>
            <el-form-item :label="$t('Invoice.IncludingTaxAmountLimit')">
              <el-input-number
                v-model="autoSplitChargeDialog.maxAmount"
                :precision="2"
                controls-position="right"
                :controls="false"
                @change="p=>{autoSplitChargeDialog.confirmSplitEnable = true;maxAmountChangeHandler(p)}"
              />
            </el-form-item>
          </div>
          <div slot="footer" style="padding-bottom: 10px; float: right">
            <el-button no="toAutoCalculateSplit" type="primary" @click="toAutoCalculateSplit">{{ $t('Invoice.AutoCalculateSplit') }}</el-button>
          </div>
        </div>
        <div style="min-height: 310px;">
          <h1 style="font-size: 20px;">{{ $t('Invoice.AutoCalculateSplitResult') }}</h1>
          <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
            <span>{{ autoSplitChargeDialog.chargeOrigin.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ autoSplitChargeDialog.chargeOrigin.currency }}</span>
          </el-form-item>
          <div class="section grid-wrapper" style="min-height: 200px;">
            <cargo-ag-grid
              :grid-options="autoSplitChargeDialog.gridOptions"
              :column-defs="autoSplitChargeDialog.columnDefs"
              :row-data="autoSplitChargeDialog.rowData"
              :check-main-record="false"
              :deselect-main-record="false"
              :auto-fit-content="false"
              style="width: 100%;"
              @gridReady="params=>{autoSplitChargeDialog.gridApi=params.api}"
            />
          </div>
          <div slot="footer" style="float: right">
            <el-button type="primary" no="doAutoSplitCharge" :disabled="autoSplitChargeDialog.confirmSplitEnable" @click="doAutoSplitCharge">{{ $t('common.btn.ok') }}</el-button>
            <el-button no="autoSplitChargeDialogCancel" @click="autoSplitChargeDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>

    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :res-data="batchCheckingWindow.resData"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
    />
  </div>
</template>

<script>

import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { generateInvoiceFaster, getGenerateInvoiceInfoFunc, saveInvoiceFasterFunc, saveSplitCharge } from '@/api/clearing/invoice'
import StrUtils from '@/utils/StrUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import { Once } from '@/utils/commonUtil'
import $store from '@/store'
import lodash from 'lodash'
import { roundHalfUp } from '@/utils/commonUtil'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import { cache, cacheName } from '@/utils/cacheManager'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { checkChargeByInvoiceSaveNode } from '@/api/booking/job'
import * as filters from '@/filters'
import { basicDataCacheKeyPrefix } from '@/utils/cacheConfig'
import CollectInvoiceWindow from '@/views/cargo/v0/Clearing/components/makeInvoice/collectInvoiceWindow.vue'
import { getObjectByCache } from '@/utils/basicDataCache'

export default {
  name: 'MakeInvoiceStepTwoDialog',
  components: { CollectInvoiceWindow, BatchCheckingWindow, ChargeCurrencyTotalGroup, NumInput },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    /**
     * params.mode: 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
     * params.paymentType: 收付方式[default:1] 1-应收开票 2-应付开票
     * params.makeInvoiceMethod: 开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单 5-付款申请模块收票弹窗
     * params.originMakeInvoiceMethod: 原始开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单
     * params.invoiceType: 发票类型[default:1] 1-普通发票 2-专用发票 3-增值税普通发票 4-增值税专用发票 5-内部发票
    params: { type: Object, required: true },*/
    properties: { type: Object, required: true },
    location: { type: String, required: false }
  },
  data() {
    const isChinese = this.$store.getters.language === 'zh'
    return {
      // gridParams: {},
      splitChargeDialog: {
        show: false,
        charge: {}, // 要拆分的费用
        chargeOrigin: {},
        splitCharge: {
          chargeName: '', // 费用名称
          currency: '', // 币种
          amount: 0.0, // 含税价
          taxRate: 0.0, // 税率
          taxAmount: 0.0, // 税额
          excludingTaxAmount: 0.0, // 不含税额
          quantity: 1, // 数量
          billingAmount: 0.0, // 对帐金额
          remarks: '' // 备注
        }, // 拆分的费用
        splitChargeForm: {
        },
        btnSplitEnable: false,
        onlyChangeQuantity: true // 拆分后“单价”不变，“数量”更新
      },
      makeInvoiceDialog: {
        visible: false,
        title: '开票',
        params: {}
      },
      chargeGrid: {
        rowData: [],
        gridParams: {},
        columnDefs: [
          // {
          //   headerName: '', initialWidth: 50, checkboxSelection: true,
          //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          //   headerCheckboxSelection: true
          // },
          {
            headerName: this.$t('Invoice.invoice_businessNumber'),
            field: 'jobNo',
            checkboxSelection: true,
            headerCheckboxSelection: true,
            initialWidth: 170
          },
          { headerName: this.$t('Invoice.invoice_mblNo'), field: 'jobMbl', initialWidth: 80 },
          { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'jobVesselFlight', initialWidth: 90 },
          { headerName: this.$t('Invoice.invoice_portOfLoading'), field: 'loadingPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            initialWidth: 80,
            filter: false,
            filterParams: {}
          },
          { headerName: this.$t('Invoice.invoice_portOfDestination'), field: 'destinationPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            initialWidth: 80,
            filter: false,
            filterParams: {}
          },
          { headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, initialWidth: 90 },
          { headerName: this.$t('Invoice.invoice_chargeItem'), field: 'chargeItemId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }, initialWidth: 100 },
          { headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'), field: 'isReceivable',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }, initialWidth: 90 },
          { headerName: this.$t('Invoice.invoice_currency'), field: 'currency', initialWidth: 70 },
          { headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount',
            cellRenderer: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }, initialWidth: 80 },
          { headerName: this.$t('Invoice.invoice_invoicingExchangeRate'), field: 'invoiceRate',
            cellRenderer: (params) => {
              return ColumnUtils.roundHalfUp(params.value, 8)
            }, initialWidth: 90 },
          { headerName: this.$t('Invoice.invoice_InvoicingAmount'), field: 'invoiceAmount2',
            cellRenderer: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }, initialWidth: 90 },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'changer',
            field: 'changer',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeOriginalExchangeRate'),
            colId: 'exchangeRate',
            field: 'exchangeRate',
            width: 100, minWidth: 100,
            hide: true
          }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onCellClicked: this.cellEventCallback,
          onRowClicked: this.onRowSelected

        }
      },
      billingGrid: {
        rowData: [],
        gridParams: {},
        columnDefs: [
          {
            headerName: this.$t('Invoice.invoice_billBusinessDate'),
            field: 'billingInputDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Invoice.invoice_mblNo'),
            field: 'jobMbl'
          },
          {
            headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
            field: 'jobVoyageFlight'
          },
          {
            headerName: this.$t('Invoice.invoice_portOfLoading'),
            field: 'jobLoadingPortEnglishName'
          },
          {
            headerName: this.$t('Invoice.invoice_portOfDestination'),
            field: 'jobDestinationPortEnglishName'
          },
          {
            headerName: this.$t('Invoice.invoice_chargeItem'),
            field: isChinese ? 'chargeItemChineseName' : 'chargeItemEnglishName'
          },
          {
            headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'),
            field: 'billingAr',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
            field: 'amount',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_taxExcludedPrice'),
            field: 'excludingTaxAmount',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_currency'),
            field: 'currency'
          },
          {
            headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
            field: 'invoiceRate',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 8) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_InvoicingAmount') + this.properties['currency'],
            field: 'invoiceAmount2',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 6) : params.value
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'changer',
            field: 'changer',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Invoice.invoice_taxAmount'),
            field: 'taxAmount',
            colId: 'taxAmount',
            initialWidth: 80,
            hide: true,
            valueFormatter: (params) => {
              return params.value ? params.value : ''
            }
          },
          {
            headerName: this.$t('Invoice.billingJob_taxRate'),
            field: 'taxRate',
            colId: 'taxRate',
            initialWidth: 80,
            hide: true,
            valueFormatter: (params) => {
              return params.value ? params.value : ''
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeOriginalExchangeRate'),
            colId: 'exchangeRate',
            field: 'exchangeRate',
            width: 100, minWidth: 100,
            hide: true
          }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Invoice.invoice_billBusinessNo'),
            field: 'billingNo',
            initialWidth: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return true
              }
            }
          },
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowClicked: this.onRowSelected
        }
      },
      billingGroupGrid: {
        rowData: [],
        gridParams: {},
        columnDefs: [
          {
            headerName: this.$t('Invoice.invoice_billBusinessDate'),
            field: 'billingGroupInputDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Invoice.invoice_mblNo'),
            field: 'jobMbl'
          },
          {
            headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
            field: 'jobVoyageFlight'
          },
          {
            headerName: this.$t('Invoice.invoice_portOfLoading'),
            field: 'jobLoadingPortEnglishName'
          },
          {
            headerName: this.$t('Invoice.invoice_portOfDestination'),
            field: 'jobDestinationPortEnglishName'
          },
          {
            headerName: this.$t('Invoice.invoice_chargeItem'),
            field: isChinese ? 'chargeItemChineseName' : 'chargeItemEnglishName'
          },
          { headerName: this.$t('Invoice.revenueAndExpenditureType'), field: 'billingGroupAr',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }, initialWidth: 90
          },
          {
            headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
            field: 'amount',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_taxExcludedPrice'),
            field: 'excludingTaxAmount',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_currency'),
            field: 'currency'
          },
          {
            headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
            field: 'invoiceRate',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 8) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_InvoicingAmount') + this.properties['currency'],
            field: 'invoiceAmount2',
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeOriginalExchangeRate'),
            colId: 'exchangeRate',
            field: 'exchangeRate',
            width: 100, minWidth: 100,
            hide: true
          }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Invoice.invoice_accountBillBusinessDate'),
            field: 'billingGroupNo',
            initialWidth: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return true
              }
            }
          },
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowClicked: this.onRowSelected
        }
      },
      billingPaymentGrid: {
        rowData: [],
        gridParams: {},
        columnDefs: [
          {
            headerName: this.$t('Invoice.invoice_mblNo'),
            field: 'jobMbl', initialWidth: 100
          },
          {
            headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
            field: 'jobVoyageFlight', initialWidth: 120
          },
          {
            headerName: this.$t('Invoice.invoice_portOfLoading'),
            field: 'jobLoadingPortEnglishName', initialWidth: 120
          },
          {
            headerName: this.$t('Invoice.invoice_portOfDestination'),
            field: 'jobDestinationPortEnglishName', initialWidth: 120
          },
          {
            headerName: this.$t('Invoice.invoice_chargeItem'),
            cellRenderer: (params) => {
              return $store.getters.language === 'zh' ? params.data.chargeItemChineseName : params.data.chargeItemEnglishName
            },
            filter: false,
            filterParams: {},
            field: 'chargeItemEnglishName',
            initialWidth: 100
          },
          {
            headerName: this.$t('Invoice.invoice_receivables') + this.$t('Invoice.invoice_payables'),
            field: 'receivable', initialWidth: 90,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
            field: 'amount', initialWidth: 100,
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_currency'),
            field: 'currency', initialWidth: 70
          },
          {
            headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
            field: 'invoiceRate', initialWidth: 100,
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 8) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_InvoicingAmount') + this.properties['currency'],
            headerClass: 'redStyle',
            field: 'invoiceAmount2', initialWidth: 120,
            cellStyle: { color: 'red' },
            cellRenderer: (params) => {
              return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
            }
          },
          {
            headerName: this.$t('Invoice.invoice_settleDepartmentPrefix'),
            field: 'settleDepartmentPrefix', initialWidth: 120,
            cellRenderer: (params) => {
              return ColumnUtils.settleDepartmentPrefixLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeOriginalExchangeRate'),
            colId: 'exchangeRate',
            field: 'exchangeRate',
            width: 100, minWidth: 100,
            hide: true
          }
        ],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Invoice.invoice_paymentNotificationAndBusiness'),
            field: 'billPaymentNo',
            initialWidth: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return true
              }
            }
          },
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowClicked: this.onRowSelected
        }
      },
      // 对冲开票
      chargeGrid_vsPage2: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid
        }
      },
      billingGrid_vsPage2: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Invoice.invoice_billBusinessNo'),
            field: 'billingNo',
            initialWidth: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return true
              }
            }
          },
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid
        }
      },
      billingGroupGrid_vsPage2: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Invoice.invoice_accountBillBusinessDate'),
            field: 'billingGroupNo',
            initialWidth: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return true
              }
            }
          },
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid
        }
      },
      billingPaymentGrid_vsPage2: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          treeData: true,
          groupDefaultExpanded: 2,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('Invoice.invoice_billBusinessNo'),
            field: 'billingNo',
            initialWidth: 240,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: false,
              checkbox: params => {
                return true
              }
            }
          },
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid
        }
      },
      gridApi_vsPage1: null,
      gridApi_vsPage2: null,
      columnApi_vsPage1: null,
      columnApi_vsPage2: null,
      once: new Once(this),
      charge1: [], // 小计：应收
      charge2: [], // 小计：应付
      allCharge: [], // 合计
      selectedCharge: {}, // 当前选中的费用
      reCalc: true, // 折合重算
      autoSplitChargeDialog: { // 自动拆分弹窗
        visible: false,
        maxAmount: 0.0, // 含税价上线
        confirmSplitEnable: true, // 确定按钮是否可用,默认不可用
        chargeOrigin: {
          chargeSource: 1, // 默认按费用开票
          sequenceNumber: 1, // 列表显示的序号（其中原费用的序号必须是1）
          uuid: '', // 费用UUID
          chargeName: '', // 费用名称
          currency: '', // 币种
          amount: 0.0, // 含税价
          excludingTaxAmount: 0.0, // 不含税额
          taxRate: 0.0, // 税率
          taxAmount: 0.0, // 税额
          quantity: 1, // 数量
          unitRate: 0.0, // 单价
          jobUuid: '',
          billingGroupUuid: '' // 对账单UUID
        },
        rowData: [], // 拆分费用列表
        gridParams: {},
        columnDefs: [
          { headerName: this.$t('SeaExport.SequenceNumber'), field: 'sequenceNumber', colId: 'sequenceNumber', initialWidth: 80 },
          { headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount', colId: 'amount', initialWidth: 80,
            cellRenderer: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }
          },
          { headerName: this.$t('Invoice.invoice_taxExcludedPrice'), field: 'excludingTaxAmount', colId: 'excludingTaxAmount', initialWidth: 80,
            cellRenderer: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }
          },
          { headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount', colId: 'taxAmount', initialWidth: 80,
            cellRenderer: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }
          },
          { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', colId: 'taxRate', initialWidth: 80 }
        ],
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false
        },
        gridApi: null
      },
      hmToFinanceApi: false,
      currencyConversionInInvoices: false,
      batchCheckingWindow: {
        lob: SystemConstants.SE.code,
        visible: false,
        jobs: [],
        resData: {},
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      showCollectInvoiceWindow: false // 是否显示收票创建业务显示详细
    }
  },
  computed: {
    // 右下角合计：ar-field
    arField() {
      return 'receivable'
    },
    // 开票方式: 1=费用、2=业务、3=账单、4=对账单
    vsPage1_makeInvoiceMethod() {
      console.log('vsPage1_makeInvoiceMethod')
      if (!this.properties.isHedge) {
        return this.properties.makeInvoiceMethod
      } else {
        if (this.properties.isAr) {
          return this.properties.makeInvoiceMethod
        } else {
          return this.properties.makeInvoiceMethodHedge // 对冲
        }
      }
    },
    vsPage1_rowData() {
      console.log('vsPage1_rowData')
      if (!this.properties.isHedge) {
        return lodash.cloneDeep(this.properties.entities)
      } else {
        const filterCurrency = this.properties.receivedRadio
        if (this.properties.isAr) {
          // 币种过滤
          if (!StrUtils.isEmpty(filterCurrency) && filterCurrency !== 'ALL') {
            return lodash.cloneDeep(this.properties.entities.filter(function(elem) {
              return (elem.currency === filterCurrency)
            }))
          } else {
            return lodash.cloneDeep(this.properties.entities)
          }
        } else {
          // 币种过滤
          if (!StrUtils.isEmpty(filterCurrency) && filterCurrency !== 'ALL') {
            return lodash.cloneDeep(this.properties.hedgeEntities.filter(function(elem) {
              return (elem.currency === filterCurrency)
            }))
          } else {
            return lodash.cloneDeep(this.properties.hedgeEntities) // 对冲
          }
        }
      }
    },
    vsPage2_makeInvoiceMethod() {
      if (this.properties.isHedge) {
        if (this.properties.isAr) {
          return lodash.cloneDeep(this.properties.makeInvoiceMethodHedge) // 对冲
        } else {
          return lodash.cloneDeep(this.properties.makeInvoiceMethod)
        }
      }
      return 0
    },
    vsPage2_rowData() {
      if (this.properties.isHedge) {
        const filterCurrency = this.properties.paymentRadio
        if (this.properties.isAr) {
          // 币种过滤
          if (!StrUtils.isEmpty(filterCurrency) && filterCurrency !== 'ALL') {
            return lodash.cloneDeep(this.properties.hedgeEntities.filter(function(elem) {
              return (elem.currency === filterCurrency)
            }))
          } else {
            return lodash.cloneDeep(this.properties.hedgeEntities) // 对冲
          }
        } else {
          // 币种过滤
          if (!StrUtils.isEmpty(filterCurrency) && filterCurrency !== 'ALL') {
            return lodash.cloneDeep(this.properties.entities.filter(function(elem) {
              return (elem.currency === filterCurrency)
            }))
          } else {
            return lodash.cloneDeep(this.properties.entities)
          }
        }
      }
      return []
    },
    rowData() {
      return this.properties.entities
    },
    rowDataHedge() {
      return this.properties.hedgeEntities
    },
    grid() {
      // todo: 设置[对冲数据]表格配置项
      const rowData = this.properties.entities
      const isChinese = this.$store.getters.language === 'zh'
      const gridParams = {}
      const chargeColumnDefs = [
        {
          headerName: '', initialWidth: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo', initialWidth: 150 },
        { headerName: this.$t('Invoice.invoice_mblNo'), field: 'jobMbl', initialWidth: 130 },
        { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'job_vesselFlight', initialWidth: 130 },
        { headerName: this.$t('Invoice.invoice_portOfLoading'), field: 'loadingPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }, initialWidth: 120 },
        { headerName: this.$t('Invoice.invoice_portOfDestination'), field: 'destinationPortCode',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          }, initialWidth: 120 },
        { headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, initialWidth: 120 },
        { headerName: this.$t('Invoice.invoice_chargeItem'), field: 'chargeItemId',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }, initialWidth: 120 },
        { headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'), field: 'isReceivable',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }, initialWidth: 100 },
        { headerName: this.$t('Invoice.invoice_currency'), field: 'currency', initialWidth: 100 },
        { headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount',
          cellRenderer: (params) => {
            return ColumnUtils.realProfitFunc(params.value)
          }, initialWidth: 100 },
        { headerName: this.$t('Invoice.invoice_invoicingExchangeRate'), field: 'invoiceRate',
          cellRenderer: (params) => {
            return ColumnUtils.roundHalfUp(params.value, 8)
          }, initialWidth: 100 },
        { headerName: this.$t('Invoice.invoice_InvoicingAmount'), field: 'invoiceAmount2',
          cellRenderer: (params) => {
            return ColumnUtils.realProfitFunc(params.value)
          }, initialWidth: 100 }
      ]
      const billingColumnDefs = [
        {
          headerName: this.$t('Invoice.invoice_billBusinessDate'),
          field: 'billingInputDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Invoice.invoice_mblNo'),
          field: 'jobMbl'
        },
        {
          headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
          field: 'jobVoyageFlight'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfLoading'),
          field: 'jobLoadingPortEnglishName'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfDestination'),
          field: 'jobDestinationPortEnglishName'
        },
        {
          headerName: this.$t('Invoice.invoice_chargeItem'),
          field: isChinese ? 'chargeItemChineseName' : 'chargeItemEnglishName'
        },
        {
          headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'),
          field: 'billingAr',
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(params.value)
          }
        },
        {
          headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
          field: 'amount',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
          }
        },
        {
          headerName: this.$t('Invoice.invoice_taxExcludedPrice'),
          field: 'excludingTaxAmount',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
          }
        },
        {
          headerName: this.$t('Invoice.invoice_currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
          field: 'invoiceRate',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 8) : params.value
          }
        },
        {
          headerName: this.$t('Invoice.invoice_InvoicingAmount') + this.properties['currency'],
          field: 'invoiceAmount2',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
          }
        }
      ]
      const billingGroupColumnDefs = [
        {
          headerName: this.$t('Invoice.invoice_billBusinessDate'),
          field: 'billingGroupInputDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Invoice.invoice_mblNo'),
          field: 'jobMbl'
        },
        {
          headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
          field: 'jobVoyageFlight'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfLoading'),
          field: 'jobLoadingPortEnglishName'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfDestination'),
          field: 'jobDestinationPortEnglishName'
        },
        {
          headerName: this.$t('Invoice.invoice_chargeItem'),
          field: isChinese ? 'chargeItemChineseName' : 'chargeItemEnglishName'
        },
        {
          headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
          field: 'amount',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
          }
        },
        {
          headerName: this.$t('Invoice.invoice_taxExcludedPrice'),
          field: 'excludingTaxAmount',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 2) : params.value
          }
        },
        {
          headerName: this.$t('Invoice.invoice_currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
          field: 'invoiceRate',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 6) : params.value
          }
        },
        {
          headerName: this.$t('Invoice.invoice_InvoicingAmount') + this.properties['currency'],
          field: 'invoiceAmount2',
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.numberColumnLabelFunc(params.value, 6) : params.value
          }
        }
      ]
      const billPaymentColumnDefs = [
        {
          headerName: this.$t('Invoice.invoice_paymentNotificationAndBusiness'),
          field: 'billPaymentNo'
        }
      ]
      const gridOptionsType1 = {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      }
      const gridOptionsType2 = {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Invoice.invoice_billBusinessNo'),
          field: 'billingNo',
          initialWidth: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        }
      }
      let columnDefs = []
      let gridOptions = {}
      // 根据开票方式动态显示表格第一列字段
      switch (this.properties.makeInvoiceMethod) {
        case 1:
        case 2: columnDefs = [...chargeColumnDefs]
          gridOptions = { ...gridOptionsType1 }
          break
        case 3: columnDefs = [...billingColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          break
        case 4: columnDefs = [...billingGroupColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          gridOptions.autoGroupColumnDef.headerName = this.$t('Invoice.invoice_accountBillBusinessDate')
          gridOptions.autoGroupColumnDef.field = 'billingGroupNo'
          break
        // 付款申请模块开票弹窗表格定义
        case 5: columnDefs = [...billPaymentColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          gridOptions.autoGroupColumnDef.headerName = this.$t('Invoice.invoice_paymentNotificationAndBusiness')
          gridOptions.autoGroupColumnDef.field = 'billPaymentNo'
          break
      }
      return { columnDefs, gridOptions, rowData, gridParams }
    },
    gridOrigin() {
      // todo: 设置[原]表格配置项
      if (!this.properties.isHedge) {
        return {}
      }
      const rowData = []
      const gridParams = {}
      const chargeColumnDefs = [
        {
          headerName: '', initialWidth: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Invoice.invoice_businessNumber'),
          field: 'job_no'
        },
        {
          headerName: this.$t('Invoice.invoice_mblNo'),
          field: 'job_mbl'
        },
        {
          headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
          field: 'job_vesselFlight'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfLoading'),
          field: 'loadingPortCode'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfDestination'),
          field: 'destinationPortCode'
        },
        {
          headerName: this.$t('Invoice.invoice_businessDate'),
          field: 'job.businessDate'
        },
        {
          headerName: this.$t('Invoice.invoice_chargeItem'),
          field: 'chargeItemId'
        },
        {
          headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'),
          field: 'isReceivable'
        },
        {
          headerName: this.$t('Invoice.invoice_currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
          field: 'amount'
        },
        {
          headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
          field: 'invoiceRate'
        },
        {
          headerName: this.$t('Invoice.invoice_InvoicingAmount'),
          field: 'invoiceAmount2'
        }
      ]
      const billingColumnDefs = [
        // {
        //   headerName: '', initialWidth: 55, checkboxSelection: true, pinned: 'left',
        //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        //   headerCheckboxSelection: true
        // },
        // {
        //   headerName: '对账单/账单/业务号',
        //   field: 'billingNo'
        // },
        {
          headerName: this.$t('Invoice.invoice_billBusinessDate'),
          field: 'inputDate'
        },
        {
          headerName: this.$t('Invoice.invoice_mblNo'),
          field: 'mbl'
        },
        {
          headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
          field: 'voyageFlight'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfLoading'),
          field: 'loadingPortCode'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfDestination'),
          field: 'destinationPortCode'
        },
        {
          headerName: this.$t('Invoice.invoice_chargeItem'),
          field: 'chargeItemId'
        },
        {
          headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
          field: 'amount'
        },
        {
          headerName: this.$t('Invoice.invoice_taxExcludedPrice'),
          field: 'excludingTaxAmount'
        },
        {
          headerName: this.$t('Invoice.invoice_currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
          field: 'invoiceRate'
        },
        {
          headerName: this.$t('Invoice.invoice_InvoicingAmount'),
          field: 'invoiceAmount2'
        }
      ]
      const billingGroupColumnDefs = [
        // {
        //   headerName: '', initialWidth: 55, checkboxSelection: true, pinned: 'left',
        //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        //   headerCheckboxSelection: true
        // },
        // {
        //   headerName: '付款通知/业务号',
        //   field: 'billPaymentNo'
        // },
        {
          headerName: this.$t('Invoice.invoice_mblNo'),
          field: 'mbl'
        },
        {
          headerName: this.$t('Invoice.invoice_vesselAndVoyage'),
          field: 'voyageFlight'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfLoading'),
          field: 'loadingPortCode'
        },
        {
          headerName: this.$t('Invoice.invoice_portOfDestination'),
          field: 'destinationPortCode'
        },
        {
          headerName: this.$t('Invoice.invoice_chargeItem'),
          field: 'chargeItemId'
        },
        {
          headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'),
          field: 'isAr'
        },
        {
          headerName: this.$t('Invoice.invoice_taxIncludedPrice'),
          field: 'amount'
        },
        {
          headerName: this.$t('Invoice.invoice_currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Invoice.invoice_invoicingExchangeRate'),
          field: 'invoiceRate'
        },
        {
          headerName: this.$t('Invoice.invoice_InvoicingAmount'),
          field: 'invoiceAmount2'
        }
      ]
      const billPaymentColumnDefs = [
        {
          headerName: this.$t('Invoice.invoice_paymentNotificationAndBusiness'),
          field: 'billPaymentNo'
        }
      ]
      const gridOptionsType1 = {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      }
      const gridOptionsType2 = {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Invoice.invoice_billBusinessNo'),
          field: 'billingNo',
          initialWidth: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        }
      }
      let columnDefs = []
      let gridOptions = {}
      switch (this.properties.makeInvoiceMethod) {
        case 1:
        case 2: columnDefs = [...chargeColumnDefs]
          gridOptions = { ...gridOptionsType1 }
          break
        case 3: columnDefs = [...billingColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          break
        case 4: columnDefs = [...billingGroupColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          gridOptions.autoGroupColumnDef.field = 'billPaymentNo'
          break
        // 付款申请模块开票弹窗表格定义
        case 5: columnDefs = [...billPaymentColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          gridOptions.autoGroupColumnDef.headerName = this.$t('Invoice.invoice_paymentNotificationAndBusiness')
          break
      }
      return { columnDefs, gridOptions, rowData, gridParams }
    },
    // 是否收票，收票需要更改国际化【仅处理-按费用、按业务、按账单、按对账单】
    isCollectInvoice() {
      return !this.properties.isAr && (this.properties.makeInvoiceMethod === 1 || this.properties.makeInvoiceMethod === 2 || this.properties.makeInvoiceMethod === 3 || this.properties.makeInvoiceMethod === 4)
    },
    txtRate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.properties.txtCurrency1)
    },
    txtRate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.properties.txtCurrency2)
    },
    unInvoiceCreate() {
      return this.properties.apInvoiceCreateMusthaveTitileAndNumber && this.isCollectInvoice
    }
  },
  async mounted() {
    // 初始化数据
    // this.fetchData()
    await cache.load(cacheName.CONFIG)
    this.hmToFinanceApi = cache.hqConfig.get('ToFinanceApi') === 'HM' // 上海虹迈
    this.currencyConversionInInvoices = Number(cache.config.get('CurrencyConversionInInvoices')) === 1
  },
  methods: {
    fetchData() {
      // this.rowData = [
      //   {
      //     billPaymentNo: 'SHSE20015072', path: 'SHSE20015072'
      //   },
      //   {
      //     billPaymentNo: 'SHSE2001500071', path: 'SHSE20015072, SHSE2001500071'
      //   },
      //   {
      //     billingNo: 'SHSE20015062', path: 'SHSE20015062'
      //   },
      //   {
      //     billingNo: 'SHSE200150001', path: 'SHSE20015062, SHSE200150001'
      //   }
      // ]
    },
    toLast() {
      // 上一步
      this.$emit('toStepHandler', 'step1')
      // // this.splitChargeDialog.splitChargeForm =
      // // todo: 需考虑该页费用拆分的保存策略，决定怎样返回上一步
      // this.$emit('update:visible', false)
    },
    toSplitCharge() {
      // const self = this
      // getGridSelectedIds(this.grid.gridOptions).then(ids => {
      //   if (ids.length === 0) {
      //     self.$message.error(self.$t('common.tips.hasOneAtleast'))
      //   } else {
      //     // this.splitChargeDialog.splitChargeForm =
      //     this.splitChargeDialog.show = true
      //   }
      // })
      if (Object.keys(this.selectedCharge).length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit'))
        return
      }
      this.splitChargeDialog.chargeOrigin = this.selectedCharge // 原始
      this.splitChargeDialog.charge = { ...this.selectedCharge } // 复制
      // const selectedEntities = getGridSelected(this.getGridOptions_vsPage1())
      // if (selectedEntities.length === 0) {
      //   this.$message.warning('请选择要拆分的费用！')
      //   return
      // }
      // this.splitChargeDialog.chargeOrigin = selectedEntities[0] // 原始
      // this.splitChargeDialog.charge = { ...selectedEntities[0] } // 复制
      console.log('splitCharge', this.splitChargeDialog.charge)
      if (this.splitChargeDialog.charge.verifiedAmount !== 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NonSplitWriteOffExpense'))
        return
      }
      if (this.hmToFinanceApi) {
        if (this.splitChargeDialog.charge.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
          return
        }
      }
      // 费用名称
      this.splitChargeDialog.charge.chargeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', this.splitChargeDialog.charge.chargeItemId, 'zhName')
      // 含税价保留小数点
      this.splitChargeDialog.charge.amount = NumberUtils.formatRoundNumber(this.splitChargeDialog.charge.amount, 2)
      this.splitChargeDialog.splitCharge.chargeName = this.splitChargeDialog.charge.chargeName
      // 币种
      this.splitChargeDialog.splitCharge.currency = this.splitChargeDialog.charge.currency
      // 税率
      this.splitChargeDialog.splitCharge.taxRate = this.splitChargeDialog.charge.taxRate
      // 重置
      this.splitChargeDialog.splitCharge.amount = 0.0
      this.splitChargeDialog.splitCharge.taxAmount = 0.0
      this.splitChargeDialog.splitCharge.excludingTaxAmount = 0.0
      this.splitChargeDialog.btnSplitEnable = false
      this.splitChargeDialog.onlyChangeQuantity = LocalStorageUtilsNew.hasConfiguration('splitChargeOnlyChangeQuantity') ? Boolean(LocalStorageUtilsNew.getConfiguration('splitChargeOnlyChangeQuantity')) : true
      this.splitChargeDialog.show = true
    },
    cancel() {
      // this.$emit('update:visible', false)
      this.showCollectInvoiceWindow = false
      this.$emit('toStepHandler', '')
    },
    // 下一步获取发票信息
    async doNexInvoice() {
      await this.generate(true)
    },
    async doMakeInvoice() {
      await this.generate(false)
    },
    // 生成发票 queryData true 则查询发票内容，不保存
    async generate(queryData = false) {
      // 实际选中
      const selectedEntities = getGridSelected(this.getGridOptions_vsPage1())
      if (this.properties.isHedge) {
        selectedEntities.push(...getGridSelected(this.getGridOptions_vsPage2()))
      }
      if (selectedEntities.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      //
      if ((!StrUtils.isEmpty(this.properties.txtCurrency1) && StrUtils.isEmpty(this.properties.txtRate1)) ||
        (!StrUtils.isEmpty(this.properties.txtCurrency2) && StrUtils.isEmpty(this.properties.txtRate2))) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExchangeRateCanTBeEmpty'))
        return
      }
      this.properties.otherRates = []
      if (this.properties.otherCurrencys.length > 2) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NECDFTIC').format(2))
        return
      } else if (this.properties.otherCurrencys.length > 0) {
        const n1 = parseFloat(this.properties.txtRate1)
        if (!this.properties.txtRate1 || n1 === 0) {
          this.$message.warning(this.$t('Message.PleaseEnterCurrencyExchangeRate'))
          return
        }
        this.properties.otherRates.push(this.properties.txtRate1)
        if (this.properties.otherCurrencys.length > 1) {
          const n2 = parseFloat(this.properties.txtRate2)
          if (!this.properties.txtRate2 || n2 === 0) {
            this.$message.warning(this.$t('Message.PleaseEnterCurrencyExchangeRate'))
            return
          }
          this.properties.otherRates.push(this.properties.txtRate2)
        }
      }
      if (this.unInvoiceCreate && this.properties.invoices && !queryData) {
        for (const invoice of this.properties.invoices) {
          if (!invoice.invoiceNo || !invoice.title) {
            this.$message.warning(this.$t('CargoMsg.Cargo_MustInvoiceNoAndTitle'))
            return
          }
        }
      }
      for (const item of selectedEntities) {
        // 若费用的报价确认为否
        if (item.chargeBusinessQuotationAmount > 0 && !item.chargeBusinessQuotationConfirmd) {
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId)
          this.$message.warning(this.$t('CargoMsg.Cargo_UnconfirmedSum', [item.jobNo, chargeItem.zhName, item.currency, item.amount]))
          return
        }
      }
      // 接口中开票类型：mode
      this.properties.mode = this.properties.typeGroup
      // titleMap
      this.properties.titleMap = this.getTitleMap()
      // invoiceByType
      this.properties.invoiceByType = this.getClassType()
      // hedgeInvoiceByType
      this.properties.hedgeInvoiceByType = this.getClassType()
      //
      if (this.properties.isGenCostInvoice) {
        const costInvoiceProp = {}
        for (const prop in this.properties) {
          costInvoiceProp[prop] = this.properties[prop]
        }
        // 开票模式
        costInvoiceProp['mode'] = 'multi'
        // 开票类型
        costInvoiceProp['invoiceType'] = 4 // 4=内部发票
        costInvoiceProp['groupingCurrencyType'] = 4
        this.properties['costInvoiceProp'] = costInvoiceProp
      }
      // 开票-勾选展示销售方银行账号可以自动根据上次操作默认勾选或取消勾选
      if ((this.properties.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || this.properties.invoiceType === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) && LocalStorageUtilsNew.hasConfiguration('invoiceDisplaySell')) {
        this.properties.invoiceDisplaySell = LocalStorageUtilsNew.getConfiguration('invoiceDisplaySell')
      }
      //
      const allCharges = []
      const chargeMap = {}
      // const checkChargeBranch = false
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const item of selectedEntities) {
          const charges = []
          if (this.properties.isGenCostInvoice && item.isOversea && !item.isReceivable) {
            continue
          }
          // CARGO-17790，H5开票界面使用按记录开票类型错误
          if (item['entity'] === 'charge' || item.entity === undefined) {
            allCharges.push(item)
            if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2) {
              charges.push(item.uuid)
              chargeMap['charge-' + item.uuid] = charges
            }
            // CARGO-15819，开票-按记录开票，却按照费用数量开出发票数量
            if (makeInvoiceMethod === 3) {
              if (!chargeMap.hasOwnProperty('billing-' + item.billingUuid)) {
                chargeMap['billing-' + item.billingUuid] = []
              }
              chargeMap['billing-' + item.billingUuid].push(item.uuid)
            } else if (makeInvoiceMethod === 4) {
              if (!chargeMap.hasOwnProperty('billingGroup-' + item.billingGroupUuid)) {
                chargeMap['billingGroup-' + item.billingGroupUuid] = []
              }
              chargeMap['billingGroup-' + item.billingGroupUuid].push(item.uuid)
            } else if (makeInvoiceMethod === 5) {
              if (!chargeMap.hasOwnProperty('billPayment-' + item.billingPaymentUuid)) {
                chargeMap['billPayment-' + item.billingPaymentUuid] = []
              }
              chargeMap['billPayment-' + item.billingPaymentUuid].push(item.uuid)
            }
          }
          // checkChargeBranch = SecurSecurityUtilityUtil.checkChargeDetailBranch(charge.branchId);
          // if(!checkChargeBranch)
          // {
          //   break;
          // }
        }
      }
      if (allCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFNBFSWWF'))
        return
      }
      this.properties.allCharges = allCharges
      this.properties.chargeMap = chargeMap
      // if (!checkChargeBranch) {
      //   MessageDialog.warning('正操作的数据所在分公司不属于当前分公司或上一级分公司.')
      //   return false
      // } else {
      //   Invoice.generateInvoiceFaster(chargeMap, properties, generateResultHandler, generateFaultHandler)
      // }
      if (queryData) {
        // 获取发票详情接口
        await this.getGenerateInvoiceInfo()
      } else {
        // 执行确认开票操作
        await this.doPreGenerateInvoiceFaster()
        this.$emit('toSaveCatchHandler')
      }
    },
    // 上一张
    btPreClickHandler() {
      let i = this.properties.currentPage
      this.properties.currentPage = --i
      this.pageChange()
    },
    // 下一张
    btNextClickHandler() {
      let i = this.properties.currentPage
      this.properties.currentPage = ++i
      this.pageChange()
    },
    // 切换发票
    pageChange() {
      this.properties.totalPage = this.properties.invoices.length
      if (this.properties.currentPage > this.properties.totalPage) {
        this.properties.currentPage = this.properties.totalPage
      }
      if (this.properties.currentPage < 1) {
        this.properties.currentPage = 1
      }
      if (this.properties.totalPage > 0) {
        this.properties.invoice = this.properties.invoices[this.properties.currentPage - 1]
      }
      if (this.showCollectInvoiceWindow) {
        this.$nextTick(() => {
          this.$refs.collectInvoiceWindow.initBaseData()
        })
      }
    },
    // 执行获取发票信息操作
    async getGenerateInvoiceInfo() {
      this.properties.unInvoiceCreate = this.unInvoiceCreate
      if (this.properties && this.properties.invoiceGoodsNameList) {
        this.properties.invoiceGoodsNameList = []
      }
      this.properties.isFei = this.properties && this.properties.groupingMakeType === 1 && (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || this.properties.toExoSystemYGSH)
      const requestBody = { 'chargeMap': this.properties.chargeMap, 'properties': this.properties, 'location': this.location }
      const loading = getLoading4Cxt(this.$refs.dialog)
      await getGenerateInvoiceInfoFunc(requestBody).then(async res => {
        this.properties.invoices = res.data
        this.showCollectInvoiceWindow = true
        this.pageChange()
      }).finally(() => {
        loading.close()
      })
    },
    // 执行生成发票操作
    async doPreGenerateInvoiceFaster() {
      // 判断是否开启验证规则
      if (String(cache.config.get('ToExoSystem')) === 'OJ') {
        const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
        // 查询是否存在节点
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code, this.$store.getters.currentOfficeId)
        if (useCheckRule && checkNodeFlag) {
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code
          const result = await this.checkNodeResult()
          if (result.needShowDialog) {
            this.batchCheckingWindow.jobs = result.jobList
            this.batchCheckingWindow.resData = result.resData
            this.batchCheckingWindow.callBack = await this.toGenerateInvoiceFaster
            this.batchCheckingWindow.callBack2 = null
            this.batchCheckingWindow.visible = true
          } else {
            await this.toGenerateInvoiceFaster()
          }
        } else {
          await this.toGenerateInvoiceFaster()
        }
      } else {
        await this.toGenerateInvoiceFaster()
      }
    },
    // 校验是否全部通过验证，是则跳过
    async checkNodeResult() {
      const result = { needShowDialog: false, jobList: [], resData: [] }

      this.properties.allCharges.forEach((item) => {
        result.jobList.push({ lob: item.jobLob, chargeUuid: item.uuid, jobNo: item.jobNo, jobUuid: item.jobUuid })
      })
      const data = {
        checkNode: CheckRuleConstants.NODE_INVOICE_CONFIRM_OR_RECEPT.code,
        chargeUuidList: result.jobList.map(item => item.chargeUuid),
        branchId: this.$store.getters.currentOfficeId,
        paymentMethod: this.properties.isAr,
        taxRate: this.properties.invoiceGoodsName ? this.properties.invoiceGoodsName.taxRate : 0,
        entities: this.properties.invoices
      }
      let needShowDialog = false
      await checkChargeByInvoiceSaveNode(data).then(res => {
        result.resData = res.data || []
        if (result.resData) {
          for (const key of Object.keys(result.resData)) {
            for (const item of result.resData[key]) {
              if (item.expressions) {
                for (const express of item.expressions) {
                  if (!express.match) {
                    needShowDialog = true
                    break
                  }
                }
              }
            }
            if (needShowDialog) {
              break
            }
          }
        }
      })
      result.needShowDialog = needShowDialog
      return result
    },
    // 获取账单所对应的结算单位
    getTitleMap() {
      const map = {}
      if (this.properties.makeInvoiceMethod === 3) {
        for (const billing of this.properties.selectedEntities) {
          map[billing.uuid] = billing.title
        }
      }
      return map
    },
    // 确认是否应当添加账单中的开票需求
    getClassType() {
      switch (this.properties.makeInvoiceMethod) {
        case 1:
        case 2:
          return 'charge'
        case 3:
          return 'billing'
        case 4:
          return 'billingGroup'
        case 5:
          return 'billPayment'
      }
      return ''
    },
    // 生成发票
    toGenerateInvoiceFaster() {
      // PILL-827 结算-对账单界面无法开票/收票
      if (this.properties && this.properties.invoiceGoodsNameList) {
        this.properties.invoiceGoodsNameList = []
      }
      this.properties.unInvoiceCreate = false
      this.properties.isFei = this.properties && this.properties.groupingMakeType === 1 && (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || this.properties.toExoSystemYGSH)
      const requestBody = { 'chargeMap': this.properties.chargeMap, 'properties': this.properties, 'location': this.location }
      const loading = getLoading4Cxt(this.$refs.dialog)
      if (this.unInvoiceCreate) {
        saveInvoiceFasterFunc(requestBody).then(res => {
          console.log('saveInvoiceFasterFunc', res.data)
          this.properties.invoices = res.data
          this.showCollectInvoiceWindow = false
          this.$emit('generatedHandler', 'step3')
        }).finally(() => {
          loading.close()
        })
      } else {
        generateInvoiceFaster(requestBody).then(res => {
          console.log('generateInvoiceFaster', res.data)
          this.properties.invoices = res.data
          //
          this.$emit('generatedHandler', 'step3')
        }).finally(() => {
          loading.close()
        })
      }
    },
    doDelete() {
      const self = this
      getGridSelectedIds(this.grid.gridOptions).then(ids => {
        if (ids.length === 0) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        } else {
          // eslint-disable-next-line no-unused-vars
          const rowDataSelected = { ...getGridSelected(self.grid.gridOptions)[0] }
          // todo: do delete and close this dialog finally
        }
      })
    },
    doDefaultSetting() {},
    doSave() {},
    lastFinsh() {
      this.makeInvoiceDialog.visible = false
      this.$emit('lastFinsh')
    },
    // 获取表格组件的gridOptions
    getGridOptions_vsPage1() {
      let gridOptions
      switch (this.vsPage1_makeInvoiceMethod) {
        case 1:
        case 2: gridOptions = this.chargeGrid.gridOptions
          break
        case 3: gridOptions = this.billingGrid.gridOptions
          break
        case 4: gridOptions = this.billingGroupGrid.gridOptions
          break
        case 5: gridOptions = this.billingPaymentGrid.gridOptions
          break
      }
      return gridOptions
    },
    getGridOptions_vsPage2() {
      let gridOptions
      switch (this.vsPage2_makeInvoiceMethod) {
        case 1:
        case 2: gridOptions = this.chargeGrid_vsPage2.gridOptions
          break
        case 3: gridOptions = this.billingGrid_vsPage2.gridOptions
          break
        case 4: gridOptions = this.billingGroupGrid_vsPage2.gridOptions
          break
        case 5: gridOptions = this.billingPaymentGrid_vsPage2.gridOptions
          break
      }
      return gridOptions
    },
    onGridReady_vsPage1(params) {
      console.log('onGridReady_vsPage1', params)
      this.gridApi_vsPage1 = params.api
      this.columnApi_vsPage1 = params.columnApi
      // 全选
      if (this.properties.useAutoCheckInvoicing) {
        const result = ClearingUtils.autoCheckInvoicingForDetail(this.vsPage1_rowData, this.properties.autoCheckInvoicingAmount, this.properties.isAr, this.vsPage1_makeInvoiceMethod)
        if (result.selectAll) {
          this.gridApi_vsPage1.selectAll()
        } else {
          for (const key of result.selectedKeys) {
            const nodes = this.gridApi_vsPage1.getModel().rowsToDisplay
            for (const item of nodes) {
              if (!item.data) {
                continue
              }
              if (item.data.uuid === key) {
                item.setSelected(true)
                item.setData(item.data)
                this.gridApi_vsPage1.ensureIndexVisible(item.rowIndex)
                break
              }
            }
          }
          if (result.message) {
            this.$message.warning(result.message)
          }
        }
      } else {
        this.gridApi_vsPage1.selectAll()
      }
      const listData = this.gridApi_vsPage1.getSelectedRows()

      // 默认聚焦最后一行以便费用拆分
      let uuid, rowIndex
      for (let i = 0; i < listData.length; i++) {
        if (listData[i].amount !== '') {
          uuid = listData[i].uuid
          break
        }
      }
      this.gridApi_vsPage1.forEachNode(node => {
        if (node.data.uuid === uuid) {
          rowIndex = node.rowIndex
        }
      })
      this.gridApi_vsPage1.setFocusedCell(rowIndex, 'jobMbl')
      const event = {
        data: listData[rowIndex]
      }
      this.onRowSelected(event)
    },
    onGridReady_vsPage2(params) {
      console.log('onGridReady_vsPage2', params)
      this.gridApi_vsPage2 = params.api
      this.columnApi_vsPage2 = params.columnApi
      // 全选
      this.gridApi_vsPage2.selectAll()
    },
    // 对冲开票，应收列表币种：全部/RMB/USD
    currencyRadioByReceivedChange(value) {
      console.log('currencyRadioByReceivedChange:', value)
      this.$nextTick(() => {
        // 全选
        this.gridApi_vsPage1.selectAll()
        const listData = this.gridApi_vsPage1.getSelectedRows()
        // 默认聚焦最后一行以便费用拆分
        let uuid, rowIndex
        for (let i = 0; i < listData.length; i++) {
          if (listData[i].amount !== '') {
            uuid = listData[i].uuid
            break
          }
        }
        this.gridApi_vsPage1.forEachNode(node => {
          if (node.data.uuid === uuid) {
            rowIndex = node.rowIndex
          }
        })
        this.gridApi_vsPage1.setFocusedCell(rowIndex, 'jobNo')
        const event = {
          data: listData[rowIndex]
        }
        this.onRowSelected(event)
      })
    },
    // 对冲开票，应付列表币种：全部/RMB/USD
    currencyRadioByPaymentChange(value) {
      console.log('currencyRadioByPaymentChange:', value)
      this.$nextTick(() => {
        this.gridApi_vsPage2.selectAll()
      })
    },
    showDialog() {
      console.log('showDialog:')
      if (this.properties.isHedge) {
        this.$nextTick(() => {
          if (this.gridApi_vsPage1 !== null) {
            this.gridApi_vsPage1.selectAll()
            this.gridApi_vsPage1.clearFocusedCell()
          }
          if (this.gridApi_vsPage2 !== null) {
            this.gridApi_vsPage2.selectAll()
          }
        })
      } else {
        this.$nextTick(() => {
          if (this.gridApi_vsPage1 !== null) {
            this.gridApi_vsPage1.selectAll()
            this.gridApi_vsPage1.clearFocusedCell()
          }
        })
      }
      this.selectedCharge = {} // 重置
    },
    // 汇率
    txtRate1Change(value) {
      console.log('txtRate1Change:', value)
      const rate = StrUtils.isEmpty(value) ? 0 : value
      this.properties.txtRate1 = NumberUtils.formatRoundNumber(rate, 8)
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const charge of this.properties.allEntities) {
          if (charge.currency === this.properties.txtCurrency1) {
            charge.invoiceRate = this.properties.txtRate1
            // charge.invoiceAmount2 = NumberUtils.roundHalfUp(charge.invoiceRate * charge.amount, 2)
            charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
          }
        }
      }
      this.reCalcSupInvoiceAmount2(makeInvoiceMethod)
      this.showDialog()
      // 刷新
      this.reSetChargeCurrencyTotalGroup()
      this.filterChange()
    },
    txtRate2Change(value) {
      console.log('txtRate2Change:', value)
      const rate = StrUtils.isEmpty(value) ? 0 : value
      this.properties.txtRate2 = NumberUtils.formatRoundNumber(rate, 8)
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const charge of this.properties.allEntities) {
          if (charge.currency === this.properties.txtCurrency2) {
            charge.invoiceRate = this.properties.txtRate2
            // charge.invoiceAmount2 = NumberUtils.roundHalfUp(charge.invoiceRate * charge.amount, 2)
            charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
          }
        }
      }
      this.reCalcSupInvoiceAmount2(makeInvoiceMethod)
      this.showDialog()
      // 刷新
      this.this.reSetChargeCurrencyTotalGroup()
      this.filterChange()
    },
    // 拆分费用含税金额
    amountChangeHandler(value) {
      console.log('amountChangeHandler', value)
      // this.splitChargeDialog.splitCharge.amount = value
      this.splitChargeDialog.splitCharge.amount = RateUtil.getAmountByCurrency(value, this.splitChargeDialog.splitCharge.currency)
      // this.splitChargeDialog.charge.amount = NumberUtils.roundHalfUp(this.splitChargeDialog.chargeOrigin.amount - value, 2)
      this.splitChargeDialog.charge.amount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.chargeOrigin.amount - this.splitChargeDialog.splitCharge.amount, this.splitChargeDialog.splitCharge.currency), 2)
      // 不含税金额
      // const rAmount = NumberUtils.roundHalfUp(this.splitChargeDialog.splitCharge.amount / (this.splitChargeDialog.splitCharge.taxRate / 100 + 1), 2)
      const rAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.amount / (this.splitChargeDialog.splitCharge.taxRate / 100 + 1), this.splitChargeDialog.splitCharge.currency), 2)
      this.splitChargeDialog.splitCharge.excludingTaxAmount = rAmount
      // this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(this.splitChargeDialog.splitCharge.amount - rAmount, 2)
      this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.amount - rAmount, this.splitChargeDialog.splitCharge.currency), 2)
      // CARGO-29312，开票详情 费用拆分 提示‘费用金额不等于不含税价加上税额’
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.splitChargeDialog.splitCharge.amount -
          this.splitChargeDialog.splitCharge.excludingTaxAmount -
          this.splitChargeDialog.splitCharge.taxAmount, 6), this.splitChargeDialog.splitCharge.currency)
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.taxAmount + c, this.splitChargeDialog.splitCharge.currency), 2)
        }
      }
    },
    // 确定拆分
    doSplitCharge() {
      this.splitChargeDialog.btnSplitEnable = true
      if (this.splitChargeDialog.splitCharge.amount === 0) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterSplitAmount'))
        return
      } else if (this.splitChargeDialog.charge.quantity > 1 && !this.splitChargeDialog.onlyChangeQuantity) {
        this.$confirm(this.$t('CargoMsg.Cargo_NOEGT1ICTSTNWBST1C'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.doSplit()
        }).catch(() => {
          this.splitChargeDialog.btnSplitEnable = false
        })
      } else {
        this.doSplit()
      }
    },
    // 拆分
    doSplit() {
      if (this.splitChargeDialog.splitCharge.amount > this.splitChargeDialog.chargeOrigin.amount && this.properties.costInfo) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('Message.TipsOnSplittingExpenses'))
        return
      }
      // 拆分的费用
      this.splitChargeDialog.splitCharge.quantity = 1
      this.splitChargeDialog.splitCharge.billingAmount = 0
      this.splitChargeDialog.splitCharge.unitRate = this.splitChargeDialog.splitCharge.excludingTaxAmount
      // 要拆分的费用
      // const rAmount = NumberUtils.roundHalfUp(this.splitChargeDialog.charge.amount / (this.splitChargeDialog.charge.taxRate / 100 + 1), 2)
      const rAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.amount / (this.splitChargeDialog.charge.taxRate / 100 + 1), this.splitChargeDialog.splitCharge.currency), 2)
      this.splitChargeDialog.charge.excludingTaxAmount = rAmount
      // this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(this.splitChargeDialog.charge.amount - rAmount, 2)
      this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.amount - rAmount, this.splitChargeDialog.splitCharge.currency), 2)
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.splitChargeDialog.charge.amount -
          this.splitChargeDialog.charge.excludingTaxAmount -
          this.splitChargeDialog.charge.taxAmount, 6), this.splitChargeDialog.splitCharge.currency)
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.taxAmount + c, this.splitChargeDialog.splitCharge.currency), 2)
        }
      }
      this.splitChargeDialog.charge.quantity = 1
      this.splitChargeDialog.charge.unitRate = this.splitChargeDialog.charge.excludingTaxAmount
      // 刷新费用参数：开票方式 1=费用、2=业务、3=账单、4=对账单
      this.splitChargeDialog.charge.chargeSource = this.properties.makeInvoiceMethod
      this.splitChargeDialog.splitCharge.chargeSource = this.properties.makeInvoiceMethod
      if (this.properties.makeInvoiceMethod === 4) { // 按对账单uuid，组装树
        this.splitChargeDialog.charge.invoiceUuid = this.splitChargeDialog.charge.billingGroupUuid
        this.splitChargeDialog.splitCharge.invoiceUuid = this.splitChargeDialog.charge.billingGroupUuid
      }
      // CARGO-53098，发票拆分时，数量也需要一起拆分
      this.splitChargeDialog.charge.splitChargeOnlyChangeQuantity = this.splitChargeDialog.onlyChangeQuantity
      //
      const charges = []
      charges.push(this.splitChargeDialog.charge)
      charges.push(this.splitChargeDialog.splitCharge)
      console.log('charges', charges)
      this.loading = getLoading()
      saveSplitCharge(charges, this.location).then(res => {
        this.splitChargeDialog.show = false
        console.log('saveSplitCharge', res)
        const splitCharges = res.data
        // 开票汇率、开票金额
        const makeInvoiceMethod = this.properties.makeInvoiceMethod
        // 记录每笔账单/对账单/付款申请单的开票总金额(开票方式为账单/对账单/付款申请单，向上汇总开票金额)
        const invoiceAmountMap = new Map()
        if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
          for (const charge of splitCharges) {
            if (charge.currency !== this.properties.currency) {
              charge.invoiceRate = this.properties.rateCache[charge.currency]
              // charge.invoiceAmount2 = NumberUtils.roundHalfUp(charge.invoiceRate * charge.amount, 2)
              charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
            } else {
              charge.invoiceRate = 1
              charge.invoiceAmount2 = charge.amount
            }
            if (charge['entity'] === 'charge') {
              let uuid = '' // 列表父节点的UUID
              if (makeInvoiceMethod === 3) {
                uuid = charge['billingUuid']
              } else if (makeInvoiceMethod === 4) {
                uuid = charge['billingGroupUuid']
              } else if (makeInvoiceMethod === 5) {
                uuid = charge['billingPaymentUuid']
              }
              if (invoiceAmountMap.has(uuid)) {
                // invoiceAmountMap.set(uuid, invoiceAmountMap.get(uuid) + charge.invoiceAmount2)
                invoiceAmountMap.set(uuid, RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid) + charge.invoiceAmount2, this.properties.currency))
              } else {
                invoiceAmountMap.set(uuid, charge.invoiceAmount2)
              }
            }
          }
        }
        if (makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) { // 处理父级显示列中的特殊字段
          for (const item of this.properties.allEntities) {
            // 树状图父节点某些字段没有值则显示为空
            if (item['entity'] !== 'charge') {
              item['amount'] = ''
              item['excludingTaxAmount'] = ''
              item['invoiceRate'] = ''
              item['invoiceAmount2'] = ''
            }

            let uuid = ''
            if (item['entity'] === 'billing' && makeInvoiceMethod === 3) {
              uuid = item['billingUuid']
            } else if (item['entity'] === 'billingGroup' && makeInvoiceMethod === 4) {
              uuid = item['billingGroupUuid']
            } else if (item['entity'] === 'billPayment' && makeInvoiceMethod === 5) {
              uuid = item['billingPaymentUuid']
            }
            if (invoiceAmountMap.has(uuid)) {
              // item['invoiceAmount2'] = NumberUtils.roundHalfUp(invoiceAmountMap.get(uuid), 2)
              item['invoiceAmount2'] = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid), this.properties.currency), 2)
            }
          }
        }
        // 刷新列表
        for (const splitCharge of splitCharges) {
          let bFlag = true // 是否拆分的费用
          for (const charge of this.properties.entities) {
            if (charge.uuid === splitCharge.uuid) {
              charge.invoiceRate = splitCharge.invoiceRate
              charge.invoiceAmount2 = splitCharge.invoiceAmount2
              charge.amount = splitCharge.amount
              charge.taxRate = splitCharge.taxRate
              charge.taxAmount = splitCharge.taxAmount
              charge.excludingTaxAmount = splitCharge.excludingTaxAmount
              charge.quantity = splitCharge.quantity
              charge.unitRate = splitCharge.unitRate
              charge.version = splitCharge.version
              //
              bFlag = false
            }
          }
          //
          for (const charge of this.properties.allEntities) {
            if (charge.uuid === splitCharge.uuid) {
              charge.invoiceRate = splitCharge.invoiceRate
              charge.invoiceAmount2 = splitCharge.invoiceAmount2
              charge.amount = splitCharge.amount
              charge.taxRate = splitCharge.taxRate
              charge.taxAmount = splitCharge.taxAmount
              charge.excludingTaxAmount = splitCharge.excludingTaxAmount
              charge.quantity = splitCharge.quantity
              charge.unitRate = splitCharge.unitRate
              charge.version = splitCharge.version
            }
          }
          if (bFlag) {
            const newCharge = []
            newCharge.push(splitCharge)
            this.properties.entities.push(...newCharge)
            this.properties.allEntities.push(...newCharge)
          }
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SplitSuccessfully'))
        // 全选
        this.showDialog()
      }).catch(() => {
        this.splitChargeDialog.btnSplitEnable = false
      }).finally(() => {
        this.loading.close()
      })
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(params) {
      if (params.api.getFocusedCell() !== null && params.api.getFocusedCell().rowIndex !== undefined) {
        const rowIndex = params.api.getFocusedCell().rowIndex
        const cell = params.api.rowModel.rowsToDisplay[rowIndex]
        const event = {}
        event.data = cell.data
        this.onRowSelected(event)
      }
      this.once.excute(this.filterChange, [], 200)
    },
    filterChange() {
      const selectedEntitiesAr = getGridSelected(this.getGridOptions_vsPage1())
      let selectedEntitiesAp = []
      if (this.properties.isHedge) {
        selectedEntitiesAp = getGridSelected(this.getGridOptions_vsPage2())
      }

      if (selectedEntitiesAr.length > 0 || selectedEntitiesAp.length > 0) {
        this.refreshSelectedCountChargeGrid(selectedEntitiesAr, selectedEntitiesAp)
      } else {
        this.getGridOptions_vsPage1().api.forEachNode(node => {
          if (node.displayed) {
            selectedEntitiesAr.push(node.data)
          }
        })
        if (this.properties.isHedge) {
          this.getGridOptions_vsPage2().api.forEachNode(node => {
            if (node.displayed) {
              selectedEntitiesAp.push(node.data)
            }
          })
        }
        this.refreshSelectedCountChargeGrid(selectedEntitiesAr, selectedEntitiesAp)
      }
    },
    refreshSelectedCountChargeGrid(selectedEntitiesAr, selectedEntitiesAp) {
      this.charge1 = []
      this.charge2 = []
      this.allCharge = []
      // 实际选中
      for (const item of selectedEntitiesAr) {
        if (item['entity'] === 'charge' || item.entity === undefined) {
          this.charge1.push(item)
        }
      }
      this.allCharge.push(...this.charge1)
      // 红冲
      if (this.properties.isHedge) {
        for (const item of selectedEntitiesAp) {
          if (item['entity'] === 'charge' || item.entity === undefined) {
            this.charge2.push(item)
          }
        }
        this.allCharge.push(...this.charge2)
      }
    },
    // 当前选中的费用
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedCharge = event.data
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2) { // 按费用/业务
        //
      } else if (this.selectedCharge['entity'] !== 'charge' && makeInvoiceMethod === 3) { // 按账单
        this.selectedCharge = {}
      } else if (this.selectedCharge['entity'] !== 'charge' && makeInvoiceMethod === 4) { // 按对账单
        this.selectedCharge = {}
      } else if (this.selectedCharge['entity'] !== 'charge' && makeInvoiceMethod === 5) { // 按账单付款申请
        this.selectedCharge = {}
      }
    },
    processCellForClipboard() {
      const txt = window.getSelection ? window.getSelection() : document.selection.createRange().text
      console.log('processCellForClipboard', txt)
      return txt
    },
    cellEventCallback(params) {
      console.log('cellClick', params.event.target, params.event.target.nodeName)
      if (params.event.target.nodeName === 'DIV' || params.event.target.nodeName === 'SPAN') {
        const selection = document.getSelection()
        const range = document.createRange()
        range.selectNode(params.event.target)
        selection.removeAllRanges()
        selection.addRange(range)
      }
    },
    getMainMenuItems_vsPage1(params) {
      return ['pinSubMenu', 'autoSizeAll', { name: this.$t('Clearing.ResetColumn'), action: this.resetState_vsPage1 }]
    },
    resetState_vsPage1() {
      console.log('resetState_vsPage1')
      this.columnApi_vsPage1.resetColumnState()
    },
    getMainMenuItems_vsPage2(params) {
      return ['pinSubMenu', 'autoSizeAll', { name: this.$t('Clearing.ResetColumn'), action: this.resetState_vsPage2 }]
    },
    resetState_vsPage2() {
      console.log('resetState_vsPage2')
      this.columnApi_vsPage2.resetColumnState()
    },
    reSetChargeCurrencyTotalGroup() {
      // 折合重算
      setTimeout(() => { this.reCalc = false }, 100)
      setTimeout(() => { this.reCalc = true }, 100)
      // 刷新
      this.$nextTick(() => {
        if (this.gridApi_vsPage1 !== null) {
          this.gridApi_vsPage1.refreshCells({ force: true })
        }
        if (this.gridApi_vsPage2 !== null) {
          this.gridApi_vsPage2.refreshCells({ force: true })
        }
      })
    },
    reCalcSupInvoiceAmount2(makeInvoiceMethod) {
      if ([3, 4, 5].includes(makeInvoiceMethod)) {
        // 记录每笔账单/对账单/付款申请单的开票总金额(开票方式为账单/对账单/付款申请单，向上汇总开票金额)
        const invoiceAmountMap = new Map()
        for (const charge of this.properties.allEntities) {
          if (charge['entity'] === 'charge') {
            let uuid = '' // 列表父节点的UUID
            if (makeInvoiceMethod === 3) {
              uuid = charge['billingUuid']
            } else if (makeInvoiceMethod === 4) {
              uuid = charge['billingGroupUuid']
            } else if (makeInvoiceMethod === 5) {
              uuid = charge['billingPaymentUuid']
            }
            if (invoiceAmountMap.has(uuid)) {
              // invoiceAmountMap.set(uuid, invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
              invoiceAmountMap.set(uuid, RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2, this.properties.currency))
            } else {
              invoiceAmountMap.set(uuid, (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
            }
          }
        }
        for (const item of this.properties.allEntities) {
          // 树状图父节点某些字段没有值则显示为空
          if (item['entity'] !== 'charge' && item.entity !== undefined) {
            item['amount'] = ''
            item['excludingTaxAmount'] = ''
            item['invoiceRate'] = ''
            item['invoiceAmount2'] = ''
          }
          let uuid = ''
          if (item['entity'] === 'billing' && makeInvoiceMethod === 3) {
            uuid = item['billingUuid']
          } else if (item['entity'] === 'billingGroup' && makeInvoiceMethod === 4) {
            uuid = item['billingGroupUuid']
          } else if (item['entity'] === 'billPayment' && makeInvoiceMethod === 5) {
            uuid = item['billingPaymentUuid']
          }
          if (invoiceAmountMap.has(uuid)) {
            // item['invoiceAmount2'] = NumberUtils.roundHalfUp(invoiceAmountMap.get(uuid), 2)
            item['invoiceAmount2'] = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid), this.properties.currency), 2)
          }
        }
      }
    },
    // 自动拆分费用
    toAutoSplitCharge() {
      if (!this.selectedCharge || Object.keys(this.selectedCharge).length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit'))
        return
      }
      if (this.selectedCharge.verifiedAmount !== 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NonSplitWriteOffExpense'))
        return
      }
      if (this.hmToFinanceApi) {
        if (this.selectedCharge.chargeSyncExternalStatus === ChargeConstants.HM_YONGYOU_SYNC_SUCCESS.code) {
          this.$message.warning(this.$t('Clearing.SyncChargeNotSplit'))
          return
        }
      }
      // 初始化界面的变量
      this.autoSplitChargeDialog.confirmSplitEnable = true
      this.autoSplitChargeDialog.maxAmount = 0.0
      this.autoSplitChargeDialog.rowData = []
      this.autoSplitChargeDialog.chargeOrigin.chargeSource = this.properties.makeInvoiceMethod
      // 序号
      this.autoSplitChargeDialog.chargeOrigin.sequenceNumber = 1
      // 费用UUID
      this.autoSplitChargeDialog.chargeOrigin.uuid = this.selectedCharge.uuid
      // 费用名称
      this.autoSplitChargeDialog.chargeOrigin.chargeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', this.selectedCharge.chargeItemId, 'zhName')
      // 含税价保留小数点
      this.autoSplitChargeDialog.chargeOrigin.amount = this.selectedCharge.amount
      // 币种
      this.autoSplitChargeDialog.chargeOrigin.currency = this.selectedCharge.currency
      // 税率
      this.autoSplitChargeDialog.chargeOrigin.taxRate = this.selectedCharge.taxRate
      // 税额
      this.autoSplitChargeDialog.chargeOrigin.taxAmount = this.selectedCharge.taxAmount
      // 不含税额
      this.autoSplitChargeDialog.chargeOrigin.excludingTaxAmount = this.selectedCharge.excludingTaxAmount
      // 业务UUID
      this.autoSplitChargeDialog.chargeOrigin.jobUuid = this.selectedCharge.jobUuid
      // 按照对账单开票时，记录按对账单uuid（和拆分费用按钮逻辑保持一致）
      if (this.properties.makeInvoiceMethod === 4) {
        this.autoSplitChargeDialog.chargeOrigin.billingGroupUuid = this.selectedCharge.billingGroupUuid
      }
      this.autoSplitChargeDialog.visible = true
    },
    // 自动计算拆分费用
    toAutoCalculateSplit() {
      if (!this.autoSplitChargeDialog.maxAmount || this.autoSplitChargeDialog.maxAmount < 0) {
        this.$message.warning(this.$t('Message.TipsOnAutoSplittingCharge'))
        return
      }
      if (this.autoSplitChargeDialog.maxAmount >= this.autoSplitChargeDialog.chargeOrigin.amount) {
        this.$message.warning(this.$t('Message.TipsOnSplittingExpenses'))
        return
      }
      const chargeOrigin = this.autoSplitChargeDialog.chargeOrigin
      const rowData = []
      // 1.复制一份原来的费用,计算公式：数量*单价*（1+税率）= 含税价
      const newOriginCharge = { ... chargeOrigin }
      newOriginCharge.amount = this.autoSplitChargeDialog.maxAmount
      newOriginCharge.unitRate = roundHalfUp(newOriginCharge.amount / (newOriginCharge.taxRate / 100 + 1) / newOriginCharge.quantity, 2)
      // newOriginCharge.excludingTaxAmount = roundHalfUp(newOriginCharge.unitRate * newOriginCharge.quantity, 2)
      // newOriginCharge.taxAmount = roundHalfUp(newOriginCharge.amount - newOriginCharge.excludingTaxAmount, 2)
      newOriginCharge.excludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newOriginCharge.unitRate * newOriginCharge.quantity, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
      newOriginCharge.taxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newOriginCharge.amount - newOriginCharge.excludingTaxAmount, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(newOriginCharge.amount -
          newOriginCharge.excludingTaxAmount -
          newOriginCharge.taxAmount, 6), this.autoSplitChargeDialog.chargeOrigin.currency)
        if (Math.abs(c) !== 0) {
          newOriginCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(newOriginCharge.taxAmount + c, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
        }
      }
      if (this.properties.makeInvoiceMethod === 4) { // 按对账单uuid，组装树
        newOriginCharge.invoiceUuid = newOriginCharge.billingGroupUuid
      }
      rowData.push(newOriginCharge)
      // 2.计算新生成的费用
      const len = Math.ceil((chargeOrigin.amount - this.autoSplitChargeDialog.maxAmount) / this.autoSplitChargeDialog.maxAmount) // 向上取整
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          if (i < len - 1) {
            const newCharge = { ... chargeOrigin }
            newCharge.uuid = ''
            newCharge.sequenceNumber = newCharge.sequenceNumber + i + 1
            newCharge.amount = this.autoSplitChargeDialog.maxAmount
            newCharge.quantity = 1
            newCharge.unitRate = roundHalfUp(newCharge.amount / (newCharge.taxRate / 100 + 1) / newCharge.quantity, 2)
            // newCharge.excludingTaxAmount = roundHalfUp(newCharge.unitRate * newCharge.quantity, 2)
            // newCharge.taxAmount = roundHalfUp(newCharge.amount - newCharge.excludingTaxAmount, 2)
            newCharge.excludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newCharge.unitRate * newCharge.quantity, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
            newCharge.taxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newCharge.amount - newCharge.excludingTaxAmount, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
            if (RateUtil.useAmountCarryRule()) {
              const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(newCharge.amount -
                newCharge.excludingTaxAmount -
                newCharge.taxAmount, 6), this.autoSplitChargeDialog.chargeOrigin.currency)
              if (Math.abs(c) !== 0) {
                newCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(newCharge.taxAmount + c, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
              }
            }
            if (this.properties.makeInvoiceMethod === 4) { // 按对账单uuid，组装树
              newCharge.invoiceUuid = newCharge.billingGroupUuid
            }
            rowData.push(newCharge)
          } else {
            const newCharge = { ... chargeOrigin }
            newCharge.uuid = ''
            newCharge.sequenceNumber = newCharge.sequenceNumber + len
            newCharge.amount = roundHalfUp(chargeOrigin.amount - this.autoSplitChargeDialog.maxAmount * len, 2)
            newCharge.quantity = 1
            newCharge.unitRate = roundHalfUp(newCharge.amount / (newCharge.taxRate / 100 + 1) / newCharge.quantity, 2)
            // newCharge.excludingTaxAmount = roundHalfUp(newCharge.unitRate * newCharge.quantity, 2)
            // newCharge.taxAmount = roundHalfUp(newCharge.amount - newCharge.excludingTaxAmount, 2)
            newCharge.excludingTaxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newCharge.unitRate * newCharge.quantity, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
            newCharge.taxAmount = roundHalfUp(RateUtil.getAmountByCurrency(newCharge.amount - newCharge.excludingTaxAmount, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
            if (RateUtil.useAmountCarryRule()) {
              const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(newCharge.amount -
                newCharge.excludingTaxAmount -
                newCharge.taxAmount, 6), this.autoSplitChargeDialog.chargeOrigin.currency)
              if (Math.abs(c) !== 0) {
                newCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(newCharge.taxAmount + c, this.autoSplitChargeDialog.chargeOrigin.currency), 2)
              }
            }
            newCharge.billingAmount = 0.0
            if (this.properties.makeInvoiceMethod === 4) { // 按对账单uuid，组装树
              newCharge.invoiceUuid = newCharge.billingGroupUuid
            }
            rowData.push(newCharge)
          }
        }
      }
      this.autoSplitChargeDialog.confirmSplitEnable = false
      this.autoSplitChargeDialog.rowData = rowData
    },
    // 确定自动拆分费用
    doAutoSplitCharge() {
      if (!this.autoSplitChargeDialog.maxAmount || this.rowData.length === 0) {
        return
      }
      this.loading = getLoading()
      saveSplitCharge(this.autoSplitChargeDialog.rowData, this.location).then(res => {
        const splitCharges = res.data
        // 开票汇率、开票金额
        const makeInvoiceMethod = this.properties.makeInvoiceMethod
        // 记录每笔账单/对账单/付款申请单的开票总金额(开票方式为账单/对账单/付款申请单，向上汇总开票金额)
        const invoiceAmountMap = new Map()
        if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
          for (const charge of splitCharges) {
            if (charge.currency !== this.properties.currency) {
              charge.invoiceRate = this.properties.rateCache[charge.currency]
              // charge.invoiceAmount2 = NumberUtils.roundHalfUp(charge.invoiceRate * charge.amount, 2)
              charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
            } else {
              charge.invoiceRate = 1
              charge.invoiceAmount2 = charge.amount
            }
            if (charge['entity'] === 'charge') {
              let uuid = '' // 列表父节点的UUID
              if (makeInvoiceMethod === 3) {
                uuid = charge['billingUuid']
              } else if (makeInvoiceMethod === 4) {
                uuid = charge['billingGroupUuid']
                charge.billingGroupNo = charge.billingNo
              } else if (makeInvoiceMethod === 5) {
                uuid = charge['billingPaymentUuid']
              }
              if (invoiceAmountMap.has(uuid)) {
                // invoiceAmountMap.set(uuid, invoiceAmountMap.get(uuid) + charge.invoiceAmount2)
                invoiceAmountMap.set(uuid, RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid) + charge.invoiceAmount2, this.properties.currency))
              } else {
                invoiceAmountMap.set(uuid, charge.invoiceAmount2)
              }
            }
          }
        }
        if (makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) { // 处理父级显示列中的特殊字段
          for (const item of this.properties.allEntities) {
            // 树状图父节点某些字段没有值则显示为空
            if (item['entity'] !== 'charge') {
              item['amount'] = ''
              item['excludingTaxAmount'] = ''
              item['invoiceRate'] = ''
              item['invoiceAmount2'] = ''
            }

            let uuid = ''
            if (item['entity'] === 'billing' && makeInvoiceMethod === 3) {
              uuid = item['billingUuid']
            } else if (item['entity'] === 'billingGroup' && makeInvoiceMethod === 4) {
              uuid = item['billingGroupUuid']
            } else if (item['entity'] === 'billPayment' && makeInvoiceMethod === 5) {
              uuid = item['billingPaymentUuid']
            }
            if (invoiceAmountMap.has(uuid)) {
              // item['invoiceAmount2'] = NumberUtils.roundHalfUp(invoiceAmountMap.get(uuid), 2)
              item['invoiceAmount2'] = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid), this.properties.currency), 2)
            }
          }
        }
        // 刷新列表
        for (const splitCharge of splitCharges) {
          let bFlag = true // 是否拆分的费用
          for (const charge of this.properties.entities) {
            if (charge.uuid === splitCharge.uuid) {
              charge.invoiceRate = splitCharge.invoiceRate
              charge.invoiceAmount2 = splitCharge.invoiceAmount2
              charge.amount = splitCharge.amount
              charge.taxRate = splitCharge.taxRate
              charge.taxAmount = splitCharge.taxAmount
              charge.excludingTaxAmount = splitCharge.excludingTaxAmount
              charge.quantity = splitCharge.quantity
              charge.unitRate = splitCharge.unitRate
              charge.version = splitCharge.version
              bFlag = false
            }
          }
          for (const charge of this.properties.allEntities) {
            if (charge.uuid === splitCharge.uuid) {
              charge.invoiceRate = splitCharge.invoiceRate
              charge.invoiceAmount2 = splitCharge.invoiceAmount2
              charge.amount = splitCharge.amount
              charge.taxRate = splitCharge.taxRate
              charge.taxAmount = splitCharge.taxAmount
              charge.excludingTaxAmount = splitCharge.excludingTaxAmount
              charge.quantity = splitCharge.quantity
              charge.unitRate = splitCharge.unitRate
              charge.version = splitCharge.version
            }
          }
          if (bFlag) {
            const newCharge = []
            newCharge.push(splitCharge)
            this.properties.entities.push(...newCharge)
            this.properties.allEntities.push(...newCharge)
          }
        }
        this.autoSplitChargeDialog.confirmSplitEnable = true
        this.autoSplitChargeDialog.maxAmount = 0.0
        this.autoSplitChargeDialog.rowData = []
        this.autoSplitChargeDialog.visible = false
        // 全选
        this.showDialog()
      }).finally(() => {
        this.loading.close()
      })
    },
    maxAmountChangeHandler(value) {
      console.log('maxAmountChangeHandler', value)
      this.autoSplitChargeDialog.maxAmount = RateUtil.getAmountByCurrency(value, this.autoSplitChargeDialog.chargeOrigin.currency)
    },
    onlyChangeQuantityChangeHandler(value) {
      LocalStorageUtilsNew.setConfiguration('splitChargeOnlyChangeQuantity', this.splitChargeDialog.onlyChangeQuantity)
    }
  }
}
</script>

<style lang="scss">
.make-invoice-step-two-dialog {
  .el-dialog__body {
    padding: 0 !important;
    .el-form-item {
      margin-bottom: 0!important;
    }
  }
  .h-dense-radio-group {
    .el-form-item {
      margin-bottom: 0 !important;
      .el-form-item__content {
        vertical-align: middle;
      }
    }
    .el-radio {
      margin-right: 6px !important;
      .el-radio__label {
        padding-left: 4px!important;
      }
    }
  }
  .ag-theme-balham {
    .ag-cell{
      user-select: text;
    }
  }
}
.make-invoice-step-two-split-charge-dialog {
  .el-form-item {
    .el-form-item__content {
      width: 40px;
      span {
        font-size: 12px;
        font-weight: bold;
      }
    }
  }
  .custom-form-item-w {
    width: 200px;
    .el-form-item__content {
      width: 130px;
    }
  }
}
  .redStyle {
    color: red;
  }

.dense-btns {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  .el-button {
    margin-left: 5px;
  }
  .el-button--mini {
    padding: 7px 12px;
  }
}
</style>
